export const CURRENT_ONBOARDING_VERSION = '1.0.0'

export const STORAGE_KEYS = {
  ONBOARDING_STATE: 'lukhas_onboarding_state',
  ONBOARDING_PROGRESS: 'lukhas_onboarding_progress',
  ONBOARDING_VERSION: 'lukhas_onboarding_version',
  USER_PREFERENCES: 'lukhas_user_preferences',
} as const

export const MODULE_TIME_ESTIMATES = {
  welcome: 2,
  legal: 10,
  security: 15,
  'system-education': 20,
  'dashboard-tour': 5,
  certification: 10,
} as const

export const QUIZ_CONFIG = {
  minPassingScore: 80,
  maxAttempts: 3,
  questionsPerQuiz: 5,
  timePerQuestion: 60,
} as const

export type OnboardingStep = keyof typeof MODULE_TIME_ESTIMATES

export type UserRole = 'staff' | 'manager' | 'admin' | 'contractor' | 'guest'

export const ROLE_DISPLAY_NAMES = {
  staff: 'Staff Member',
  manager: 'Manager',
  admin: 'Administrator',
  contractor: 'Contractor',
  guest: 'Guest',
} as const

export const ROLE_DESCRIPTIONS = {
  staff: 'Full-time team member with standard access',
  manager: 'Team lead with management capabilities',
  admin: 'System administrator with full access',
  contractor: 'External contractor with limited access',
  guest: 'Temporary guest access',
} as const

export const ROLE_TIME_ESTIMATES = {
  staff: { min: 30, max: 45 },
  manager: { min: 45, max: 60 },
  admin: { min: 60, max: 90 },
  contractor: { min: 15, max: 25 },
  guest: { min: 5, max: 10 },
} as const

export const STORAGE_KEYS_EXTENDED = {
  ...STORAGE_KEYS,
  telemetryBuffer: 'lukhas_telemetry_buffer',
  onboardingStore: 'lukhas_onboarding_store',
} as const
